angular.module('webcomm').controller('TextMessageEventController', ['$scope', '$log', '$timeout', 'timeFormattingService', function ($scope, $log, $timeout, timeFormattingService) {
    $scope.leftOrRight = $scope.feedEvent.data.Self ? "right" : "left";
    $scope.stretchOrFixed = $scope.feedEvent.data.message.length < 60 ? "stretch" : "fixed";
    $scope.retry = false;
    $scope.messageStatus = $scope.feedEvent.confirmed ? "sent" : "sending";
    $scope.feedMessage = htmlEncode($scope.feedEvent.data.message);
    $scope.important = $scope.feedEvent.data.important ? "text-alert" : "";
    
    var unbindIsReconnecting;

    // delete the watchers if we're re-loading this channel
    if ($scope.feedEvent.confirmed) {
        destroyScopes();
    }

    if(typeof $scope.feedEvent.clientTime === 'object') {
        $scope.timeSent = timeFormattingService.formatFeedDate($scope.feedEvent.clientTime);
    }
    else {
        $scope.timeSent = $scope.feedEvent.clientTime;
        $scope.errorMessage = $scope.feedEvent.errorMessage;

        unbindIsReconnecting = $scope.$on('isReconnecting', function(event, data) {
            if (!data) {
                $scope.retry = true;
            }
        });
    }

    var unbindTextMessageSentError = $scope.$on('textMessageSentError', function(event, feedId, err) {
        if ($scope.feedEvent.feedId === feedId) {
            $scope.messageStatus = "error";
            $scope.errorMessage = $scope.feedEvent.errorMessage = err;
            $scope.feedEvent.confirmed = true;
            $scope.timeSent = $scope.feedEvent.clientTime = "error";
            destroyScopes();
        }
    });

    var unbindTextMessageSentConfirmed = $scope.$on('textMessageSentConfirmed', function(event, feedId) {
        if ($scope.feedEvent.feedId === feedId) {
            $scope.messageStatus = "sent";
            $scope.feedEvent.confirmed = true;
            $scope.timeSent = timeFormattingService.formatFeedDate($scope.feedEvent.clientTime);
            destroyScopes();
        }
    });

    var unbindTextFeedFinished = $scope.$on('textMessageService.textMessageComplete', function(e, feedId) {
        $scope.feedEvent.confirmed = true;
        destroyScopes();
    });

    function destroyScopes() {
        $timeout(function () {
            $scope.$parent.$parent.$destroy();
        }, 0);
    }

    $scope.$on('destroy', function() {
        if(unbindIsReconnecting) {
            unbindIsReconnecting();
        }
        
        unbindTextMessageSentConfirmed();
        unbindTextMessageSentError();
        unbindTextFeedFinished();
        
        $log.debug('text message event scope destroyed');
    });
}]);